import { render, staticRenderFns } from "./cms-block-list-category.vue?vue&type=template&id=c7710eea&scoped=true"
import script from "./cms-block-list-category.vue?vue&type=script&lang=js"
export * from "./cms-block-list-category.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7710eea",
  null
  
)

export default component.exports